import { batch } from 'react-redux';

import { viewDocument } from './DocumentViewerActions';
import { handleErrors } from './ErrorActions';
import {
  lockPanelLayoutConfig,
  setPanelLayoutConfig,
  unlockPanelLayoutConfig,
} from './PanelLayoutActions';
import * as certificationApi from '../api/certification';
import * as translationsApi from '../api/translations';
import { ACTOR_TYPES } from '../constants/Common';
import { PANEL_CONFIGURATIONS } from '../constants/PanelLayoutConstants';
import {
  ACTOR_CERTIFICATION_ENTITY_NAME,
  ACTOR_CERTIFICATION_FORM_KEY,
  ACTOR_TRAINER_CERTIFICATION_FORM_KEY,
  CONTENT_TYPES,
  PERSON_CERTIFICATION_ENTITY_NAME,
  PERSON_CERTIFICATION_FORM_KEY,
  PERSON_TRAINER_CERTIFICATION_FORM_KEY,
  SET_SUBMIT_INITIATED,
} from '../containers/CertificationPage/constants';
import { createCertificationEntity } from '../form-designer/actions/form-manager.actions';
import { FORM_KEYS } from '../form-designer/constants/form-manager.constants';

export const CHECK_CLASSROOM_TRAINING_REQUIRED_SUCCESS =
  'Certification/CHECK_CLASSROOM_TRAINING_REQUIRED_SUCCESS';
export const REQUIREMENT_PREREQUISITE_STATUS_SUCCESS =
  'Certification/REQUIREMENT_PREREQUISITE_STATUS_SUCCESS';
export const CLEAR_CERTIFICATION_DATA = 'Certification/CLEAR_CERTIFICATION_DATA';
export const SET_OPEN_ERRORS_TAB_CERTIFICATION = 'Certification/SET_OPEN_ERRORS_TAB_CERTIFICATION';

export const checkPreRequisiteStatus = ({ actorId, rpgId }) => async (dispatch) => {
  try {
    const requisiteStatusData = await certificationApi.checkPreRequisiteStatus({ actorId, rpgId });

    if (requisiteStatusData.hasError) {
      dispatch(handleErrors(requisiteStatusData.errors));
      return;
    }

    const {
      preRequisiteIsRequired,
      warningToDisplay,
      preRequisiteStatus,
      preRequisites,
    } = requisiteStatusData;

    if (preRequisiteIsRequired) {
      const data = {
        preRequisiteIsRequired,
        message: warningToDisplay,
        preRequisiteStatus,
        preRequisites,
      };

      batch(() => {
        dispatch(lockPanelLayoutConfig());
        dispatch({
          type: REQUIREMENT_PREREQUISITE_STATUS_SUCCESS,
          payload: data,
        });
      });
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(`CertificationActions.checkPreRequisiteStatus() failed: ${error.stack}`);
  }
};

export const loadContent = ({
  contentType,
  reqId,
  shouldLoadCertification,
  isTrainerSignOff,
  checkPreRequisiteIsRequired,
  actorId,
  rpgId,
  actorClass,
  entityType,
  formKey,
}) => (dispatch) => {
  const displayCertification = (entityName, formKey) => {
    dispatch(
      createCertificationEntity({
        storeKey: FORM_KEYS.STEP,
        formKey,
        itmId: actorId,
        stepId: rpgId,
        entityType: entityName,
        trainerSignOff: isTrainerSignOff,
      })
    );
  };

  batch(() => {
    if (CONTENT_TYPES.includes(contentType)) {
      dispatch(viewDocument({ docId: reqId }));
    }

    if (!shouldLoadCertification) {
      return;
    }

    // TODO: might need to move this up
    dispatch(unlockPanelLayoutConfig());

    if (isTrainerSignOff) {
      dispatch(setPanelLayoutConfig(PANEL_CONFIGURATIONS.ONLY_MIDDLE));
    } else {
      if (checkPreRequisiteIsRequired) {
        dispatch(checkPreRequisiteStatus({ actorId, rpgId }));
      }
      dispatch(
        createCertificationEntity({
          storeKey: FORM_KEYS.DETAIL,
          formEntityKey: formKey,
          formKey,
          itmId: reqId,
          stepId: rpgId,
          entityType,
          certificationData: false,
        })
      );
      dispatch(setPanelLayoutConfig(PANEL_CONFIGURATIONS.LEFT_COLLAPSED));
    }

    switch (actorClass) {
      case ACTOR_TYPES.PERSON:
        displayCertification(
          PERSON_CERTIFICATION_ENTITY_NAME,
          isTrainerSignOff ? PERSON_TRAINER_CERTIFICATION_FORM_KEY : PERSON_CERTIFICATION_FORM_KEY
        );
        return;

      case ACTOR_TYPES.INTERNAL_ACTOR:
        displayCertification(
          ACTOR_CERTIFICATION_ENTITY_NAME,
          isTrainerSignOff ? ACTOR_TRAINER_CERTIFICATION_FORM_KEY : ACTOR_CERTIFICATION_FORM_KEY
        );
        return;

      default:
        return;
    }
  });
};

export const checkClassRoomTrainingRequired = ({ trainingProgress, actorId, rpgId }) => async (
  dispatch
) => {
  try {
    const apiData = await certificationApi.classRoomTrainingIsRequired({
      trainingProgress,
      actorId,
      rpgId,
    });

    if (apiData.hasError) {
      dispatch(handleErrors(apiData.errors));
      return;
    }

    let message = null;
    const { classRoomTrainingIsRequired } = apiData;

    if (classRoomTrainingIsRequired) {
      const { Translation } = await translationsApi.translateString(
        'msgClassroomTrainingIsRequired'
      );
      message = Translation;
    }

    dispatch({
      type: CHECK_CLASSROOM_TRAINING_REQUIRED_SUCCESS,
      payload: {
        classRoomTrainingIsRequired,
        message,
      },
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(`CertificationActions.checkClassRoomTrainingRequired() failed: ${error.stack}`);
  }
};

export const setOpenErrorsTabCertification = (openErrorsTab) => ({
  type: SET_OPEN_ERRORS_TAB_CERTIFICATION,
  payload: { openErrorsTab },
});

export const setSubmitInitiated = (isSubmitInitiated) => ({
  type: SET_SUBMIT_INITIATED,
  payload: { isSubmitInitiated },
});

export const clearCertificationData = () => async (dispatch) => {
  dispatch({
    type: CLEAR_CERTIFICATION_DATA,
  });
};
